import {Component, ViewEncapsulation} from '@angular/core';

@Component({
    moduleId: module.id,
    selector: 'md-select',
    templateUrl: 'select.html',
    styleUrls: ['select.css'],
    encapsulation: ViewEncapsulation.None
})
export class MdSelect {}
